import { literal, object, string } from 'superstruct';

import { ListResourceDto } from '@adflow/shared/util-data';
import { adflowApiSchema } from '@adflow/shared/util-route-schema';
import { parsableInteger } from '@adflow/shared/util-superstruct';

import { AddMediaDto } from './add-media.dto';
import { EditMediaDto } from './edit-media.dto';
import { ListMediaQueryDto } from './list-media-query.dto';
import { ViewMediaDto } from './view-media.dto';

const p = adflowApiSchema.prefix('media/facebook');

export const ListFacebookMedias = p.get('', {
	req: object({
		query: ListMediaQueryDto,
	}),
	res: ListResourceDto(ViewMediaDto),
});

export const GetFacebookMedia = p.get(':mediaId', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: ViewMediaDto,
});

export const AddFacebookMedia = p.post('', {
	req: object({
		body: AddMediaDto,
	}),
	res: object({
		file: ViewMediaDto,
		signedUrl: string(),
	}),
});

export const ProcessFacebookMedia = p.post(':mediaId/process', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: ViewMediaDto,
});

export const EditFacebookMedia = p.patch(':mediaId', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
		body: EditMediaDto,
	}),
	res: ViewMediaDto,
});

// export const ArchiveFacebookMedia = p.delete(':mediaId', {
// 	req: object({
// 		params: object({ mediaId: parsableInteger() }),
// 	}),
// 	res: literal(undefined),
// });

export const DeleteFacebookMedia = p.delete(':mediaId', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: literal(undefined),
});

export const DownloadMedia = p.get(':mediaId/download', {
	req: object({
		params: object({ mediaId: parsableInteger() }),
	}),
	res: object({}),
});
